import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Logo } from "../Logo";
import { useLead } from "../../context/LeadContext";
import { ArrowRight } from "lucide-react";

export const Footer = () => {
  const { openLeadForm } = useLead();
  return (
    <footer className="bg-charcoal text-white" data-testid="footer">
      {/* CTA band */}
      <div className="mx-auto max-w-6xl px-5 py-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] px-8 py-14 text-center sm:px-16"
        >
          <div className="pointer-events-none absolute -left-20 -top-20 h-72 w-72 rounded-full bg-brand/25 blur-3xl" />
          <h2 className="mx-auto max-w-3xl font-display text-4xl font-black tracking-tighter sm:text-5xl">
            Give every lead a reply in 5 seconds, starting today.
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/60">
            Unlock a personalized demo built around your industry and lead volume. No credit card, no sales call to start.
          </p>
          <Button
            data-testid="footer-cta-btn"
            onClick={() => openLeadForm({ source: "footer" })}
            className="group mt-8 h-13 bg-brand px-8 py-6 text-base font-bold text-white hover:bg-brand-hover"
          >
            Get my personalized demo
            <ArrowRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Button>
        </motion.div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-5 py-8 sm:flex-row">
          <Logo dark />
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/60">
            <a href="/#simulator" className="hover:text-white">Simulator</a>
            <a href="/#how" className="hover:text-white">How it works</a>
            <a href="/#roi" className="hover:text-white">ROI</a>
            <Link to="/pricing" className="hover:text-white">Pricing</Link>
          </nav>
          <p className="text-xs text-white/40">© {new Date().getFullYear()} Digimonk.AI</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
